import * as t from "io-ts";
import { UnexpectedValueError } from "../unexpected-value-error";

interface UnresolvedStaticPathBrand {
  readonly UnresolvedStaticPath: unique symbol;
}

export const UnresolvedStaticPath = t.brand(
  t.string,
  (n): n is t.Branded<string, UnresolvedStaticPathBrand> => true,
  "UnresolvedStaticPath"
);
export type UnresolvedStaticPath = t.TypeOf<typeof UnresolvedStaticPath>;
export type UnresolvedStaticPathOutput = typeof UnresolvedStaticPath._O;

export const emptyUnresolvedStaticPath = "" as UnresolvedStaticPath;

interface ResolvedStaticPathBrand {
  readonly ResolvedStaticPath: unique symbol;
}

export const ResolvedStaticPath = t.brand(
  t.string,
  (n): n is t.Branded<string, ResolvedStaticPathBrand> => true,
  "ResolvedStaticPath"
);
export type ResolvedStaticPath = t.TypeOf<typeof ResolvedStaticPath>;
export type ResolvedStaticPathOutput = typeof ResolvedStaticPath._O;

export const emptyResolvedStaticPath = "" as ResolvedStaticPath;

export function resolveStaticPath(StaticPath: UnresolvedStaticPath): ResolvedStaticPath
export function resolveStaticPath(StaticPath: null): null
export function resolveStaticPath(StaticPath: undefined): undefined
export function resolveStaticPath(StaticPath: UnresolvedStaticPath | undefined): ResolvedStaticPath | undefined
export function resolveStaticPath(StaticPath: UnresolvedStaticPath | null): ResolvedStaticPath | null
export function resolveStaticPath(StaticPath: UnresolvedStaticPath | null | undefined): ResolvedStaticPath | null | undefined
export function resolveStaticPath(StaticPath: UnresolvedStaticPath | null | undefined): ResolvedStaticPath | null | undefined {
  if (StaticPath === null)
    return null;

  if (StaticPath === undefined)
    return undefined;

  if (StaticPath.startsWith("s3://")) {
    const fileName = StaticPath.substring(5);
    return UnexpectedValueError.throwIfNot("resolve logo path",
      ResolvedStaticPath,
      `/api/resources/static/${fileName}`);
  }

  return UnexpectedValueError.throwIfNot(
    "resolve logo path",
    ResolvedStaticPath, StaticPath);
}